import { render, staticRenderFns } from "./LogoWhatNotToDoSection.vue?vue&type=template&id=36106525"
import script from "./LogoWhatNotToDoSection.vue?vue&type=script&lang=ts"
export * from "./LogoWhatNotToDoSection.vue?vue&type=script&lang=ts"
import style0 from "./LogoWhatNotToDoSection.vue?vue&type=style&index=0&id=36106525&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports